/**
 * Flattens a calibration, service, part, or labour item
 * into a UI-friendly structure.
 *
 * @param {Object} item - Item object returned from QWI API
 * @param {string} type - One of: 'calibration' | 'service' | 'part' | 'labour'
 * @returns {Object} Flattened item
 */
export const flattenItem = (item, type) => {
  const nested = item?.[type]
  return {
    ...item,
    [`${type}_id`]: nested?.id,
    name: nested?.name,
    price: item.cost_price,
    description: item?.description,
    calibration_center_id: nested?.calibration_center_id,
    itemNum: nested?.itemNum,
    category: nested?.category,
    is_defaulted: nested?.is_defaulted,
    is_active: nested?.is_active,
    calibration_created_at: nested?.created_at,
    calibration_updated_at: nested?.updated_at,
    category_id: item?.category?.id
  }
}

/**
 * Converts an array of items into a map keyed by itemNum,
 * and marks items as `checked` if their itemNum is selected.
 *
 * @param {Array} data - Array of items
 * @param {Array} selectedItems - Array of selected itemNum values
 * @returns {Object} Map of itemNum -> item with checked status
 */
export const transformToMap = (data = [], selectedItems = []) => {
  return data.reduce((map, item) => {
    map[item.itemNum] = {
      ...item,
      checked: selectedItems.includes(item.itemNum)
    }
    return map
  }, {})
}

export const formatItemList = (response) => {
  const map = {}
  if (response?.status === 200) {
    response.data.forEach((item) => {
      map[item.itemNum] = item
    })
  }
  return map
}

export const normalizeCustomItems = (items = []) =>
  items.map((item) => ({
    ...item,
    category_id: item.category?.id,
    price: item.cost_price
  }))

export const splitCustomItems = (items = []) => {
  const rebateItems = []
  const standardItems = []
  items.forEach((item) => {
    if (item.is_client_rebate_applied) {
      rebateItems.push(item)
    } else {
      standardItems.push(item)
    }
  })
  return { rebateItems, standardItems }
}
